import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { useAuthStore } from '../application/stores/auth.store';
import Loader from '../components/common/Loaders/Loader';
import Dashboard from '../components/pages/Dashboard/Dashboard';
import Documentation from '../components/pages/Documentation/Documentation';
import { DocumentGenerationPage } from '../components/pages/Documentation/DocumentGenerationPage';
import { ErrorEnum } from '../components/pages/Error/ErrorEnum';
import ErrorPage from '../components/pages/Error/ErrorPage';
import Form from '../components/pages/Form/Form';
import Summary from '../components/pages/Form/Summary/Summary';
import { OtForm } from '../components/pages/Forms/PDD/Ots/OtForm';
import OTsList from '../components/pages/Forms/PDD/Ots/OtsList/OtsList';
import { PDDFormPage } from '../components/pages/Forms/PDD/PDDFormPage';
import { PDDFormSummary } from '../components/pages/Forms/PDD/PDDFormSummary';
import Login from '../components/pages/Login/Login';
import LoginSage from '../components/pages/LoginSage/LoginSage';
import Payments from '../components/pages/Payments/Payments';
import PaymentsFeedbackKo from '../components/pages/Payments/PaymentsFeedback/PaymentsFeedbackKo';
import PaymentsFeedbackOk from '../components/pages/Payments/PaymentsFeedback/PaymentsFeedbackOk';
import Register from '../components/pages/Register/Register';
import ResetPassword from '../components/pages/ResetPassword/ResetPassword';
import UserProfile from '../components/pages/UserProfile/UserProfile';
import { ProtectedClientRoute } from './ProtectedClientRoute';
import { ProtectedRoute } from './ProtectedRoute';
import FormRoutes from './wrappers/FormRoutes';
import ProtectedRoutes from './wrappers/ProtectedRoutes';
const Routes = () => {
    const { isAuthReady, isAuthenticated } = useAuthStore();
    const [router, setRouter] = useState(null);
    const routesForAuthenticatedOnly = [
        {
            path: '/',
            element: _jsx(ProtectedRoute, {}),
            children: [
                { path: '/', element: _jsx(ProtectedRoutes, { children: _jsx(Dashboard, {}) }) },
                { path: '/form-old', element: _jsx(FormRoutes, { children: _jsx(Form, {}) }) },
                { path: '/form', element: _jsx(ProtectedRoutes, { children: _jsx(PDDFormPage, {}) }) },
                { path: '/ot-form/:id/:name', element: _jsx(ProtectedRoutes, { children: _jsx(OtForm, {}) }) },
                { path: '/ot-list/:serviceFormFillingId', element: _jsx(ProtectedRoutes, { children: _jsx(OTsList, {}) }) },
                { path: '/document-generation/:serviceFormFillingId', element: _jsx(ProtectedRoutes, { children: _jsx(DocumentGenerationPage, {}) }) },
                { path: '/documentation', element: _jsx(ProtectedRoutes, { children: _jsx(Documentation, {}) }) },
                { path: 'form/summary-form-old', element: _jsx(ProtectedRoutes, { children: _jsx(Summary, {}) }) },
                { path: '/form/summary-form', element: _jsx(ProtectedRoutes, { children: _jsx(PDDFormSummary, {}) }) },
                { path: 'user-profile', element: _jsx(ProtectedRoutes, { children: _jsx(UserProfile, {}) }) },
                { path: '*', element: _jsx(Navigate, { to: "/" }) }
            ],
            errorElement: _jsx(ErrorPage, { error: ErrorEnum.GENERIC }),
        },
    ];
    const routesForNotAuthenticatedOnly = [
        {
            path: '/',
            element: _jsx(ProtectedClientRoute, {}),
            children: [
                { path: '/', element: _jsx(ErrorBoundary, Object.assign({ fallback: _jsx(ErrorPage, { error: ErrorEnum.GENERIC }) }, { children: _jsx(Login, {}) })) },
                { path: '/login', element: _jsx(ErrorBoundary, Object.assign({ fallback: _jsx(ErrorPage, { error: ErrorEnum.GENERIC }) }, { children: _jsx(Login, {}) })) },
                //{ path: '/sage/:id', element: <ErrorBoundary fallback={<ErrorPage error={ErrorEnum.GENERIC} />}><LoginSage /></ErrorBoundary> },
                { path: '/registro', element: _jsx(ErrorBoundary, Object.assign({ fallback: _jsx(ErrorPage, { error: ErrorEnum.GENERIC }) }, { children: _jsx(Register, {}) })) },
                { path: '/payments/:companyIdParam', element: _jsx(ErrorBoundary, Object.assign({ fallback: _jsx(ErrorPage, { error: ErrorEnum.GENERIC }) }, { children: _jsx(Payments, {}) })) },
                { path: '/payments/feedback-ok', element: _jsx(ErrorBoundary, Object.assign({ fallback: _jsx(ErrorPage, { error: ErrorEnum.GENERIC }) }, { children: _jsx(PaymentsFeedbackOk, {}) })) },
                { path: '/payments/feedback-ko', element: _jsx(ErrorBoundary, Object.assign({ fallback: _jsx(ErrorPage, { error: ErrorEnum.GENERIC }) }, { children: _jsx(PaymentsFeedbackKo, {}) })) },
                { path: '/reset-password/:hashPassword', element: _jsx(ErrorBoundary, Object.assign({ fallback: _jsx(ErrorPage, { error: ErrorEnum.GENERIC }) }, { children: _jsx(ResetPassword, {}) })) },
                { path: '*', element: _jsx(Navigate, { to: "/", replace: true }) }
            ],
            errorElement: _jsx(ErrorPage, { error: ErrorEnum.GENERIC }),
        },
    ];
    const commonRoutes = [
        { path: '/sage/*', element: _jsx(ErrorBoundary, Object.assign({ fallback: _jsx(ErrorPage, { error: ErrorEnum.GENERIC }) }, { children: _jsx(LoginSage, {}) })) },
    ];
    const routes = useMemo(() => {
        if (!isAuthReady)
            return [];
        const baseRoutes = isAuthenticated ? routesForAuthenticatedOnly : routesForNotAuthenticatedOnly;
        return [...baseRoutes, ...commonRoutes];
    }, [isAuthReady, isAuthenticated]);
    useEffect(() => {
        if (routes.length > 0) {
            const r = createBrowserRouter(routes);
            setRouter(r);
        }
    }, [routes]);
    if (!router)
        return _jsx(Loader, { fullBlack: true });
    return (_jsx(ErrorBoundary, Object.assign({ FallbackComponent: () => _jsx(ErrorPage, { error: ErrorEnum.GENERIC }) }, { children: _jsx(RouterProvider, { router: router }) })));
};
export default Routes;
